import React from 'react';
import PayProcess from '@containers/Pay/PayProcess';

const PaymentTerminalPaymentScreen = ({
  paymentType,
  // handlePrint,
  paymentCallBack,
  handleFailureRoute,
  handleProcessCreditError,
  // ...props
}) => {
  
  const HandlePaymentScreenType = () => {
    switch (paymentType) {
      // case 1: return StartScreen();
      // case 2: return Fullcheck();
      case 3: return <PayProcess paymentCallBack={paymentCallBack} handleFailureRoute={handleFailureRoute} handleProcessCreditError={handleProcessCreditError} />;
      // case 4: return Tips();
      // case 5: return PaymentRecipt();
      // case 6: return PaymentConfirmationSuccess();
      // case 7: return PaymentConfirmationError();
      // case 8: return PaymentErrorRetry();
      // case 9: return handleSplitEvenlyModal();
      // case 10: return handlePayAnAmountModal();
      // case 11: return <Survey handleSurveySubmit={handleSurveySubmit} />;
      // case 12: return <GiftCard isSecurityCode={isSecurityCode} giftBalance={giftBalance} paymentAmount={Number(totalAmount) - Number(paidAmount) + Number(tipAmount)} giftCardPayment={giftCardPayment} onSubmit={handleGiftCard} giftCardSupportsSwipe={giftCardSupportsSwipe} openCardPopUp={openCardPopUp} giftCardNumber={giftCardNumber} handleGiftCancel={handleGiftCancel} />;
      // case 13: return <Charity />;
      // case 14: return <QrPayFromPhone handleCheck={handleCheck} />;
      // case 15: return <IngenicoPayment />;
      // case 16: return <CashReturn deviceInfo={deviceInfo} totalAmount={totalAmount} paymentType={paymentType} handleCheck={handleCheck} userInfo={userInfo} setDrawerVisiblityProps={setDrawerVisiblityProps} />;
      // case 17: return <CashReturn receiptTypes={receiptTypes} handleHideCancelIcon={handleHideCancelIcon} deviceInfo={deviceInfo} isCounter={isCounter} totalAmount={totalAmount} paymentType={paymentType} handleCheck={handleCheck} userInfo={userInfo} setDrawerVisiblityProps={setDrawerVisiblityProps} />;
      // case 18: return <CashReturn receiptTypes={receiptTypes} handleHideCancelIcon={handleHideCancelIcon} deviceInfo={deviceInfo} isCounter={isCounter} totalAmount={totalAmount} paymentType={paymentType} handleReceiptPopUpOpen={handleReceiptPopUpOpen} userInfo={userInfo} handleCheck={handleCheck} setDrawerVisiblityProps={setDrawerVisiblityProps} />;
      default: return <div />;
    }
  };

  return (
    <>
      {HandlePaymentScreenType()}
    </>
  );
};

export default PaymentTerminalPaymentScreen;
